import LoopIcon from "@mui/icons-material/Loop";
import {
  Box,
  Button,
  IconButton,
  Skeleton,
  Tab,
  Tabs,
  useMediaQuery,
} from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Search from "../../../../components/inputs/search";
import { API } from "../../../../scripts/api";
import axiosInstance from "../../../../scripts/axiosInspector";
import ProductCart from "./productCart";
const Step3 = ({
  dataS,
  setDataS,
  seleted,
  setSeleted,
  currencyOption,
  allGroups,
  selectedGroup,
  setSelectedGroup,
}) => {
  const [data, setData] = useState([]);
  const [Idata, setIData] = useState([]);
  const [hasChecked, setHasChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  const CurrentCompany = useSelector((state) => state.CurrentCompany);
  const { company } = CurrentCompany;
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  const [searchData, setSearchData] = useState("");
  const isMd = useMediaQuery("(min-width:756px)");
  const [money, setMoney] = useState(0);
  const [value, setValue] = useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  useEffect(() => {
    getData("", true);
  }, [selectedGroup?.guidRecNo]);
  const getData = (search, clear) => {
    setLoading(true);
    var temp = [...Idata];
    if (clear) temp = [];
    axiosInstance
      .get(
        API.info.stuff +
          `?guidStateRecNo=${company?.guidRecNo}${
            dataS?.guidBuyerRecNo
              ? `&guidBuyerRecNo=${dataS?.guidBuyerRecNo}`
              : ""
          }${search ? `&chStuffName=${search}` : ""}${
            selectedGroup?.guidRecNo
              ? `&guidSellerStuffGroupRecNo=${selectedGroup?.guidRecNo}`
              : ""
          }`,
        {
          headers: {
            Authorization: `Bearer ${userInfo?.token}`,
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
            "Accept-Language": "fa-IR",
            chHostName: process.env.REACT_APP_CHHOSTNAME,
          },
        }
      )
      .then((res) => {
        if (!search && temp.length === 0) setIData(res?.data?.data);
        setData(res?.data?.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (userInfo) {
        setLoading(true);
        setHasChecked(false);
        if (searchData && searchData !== "undefined" && !hasChecked) {
          getData(searchData);
        } else {
          setLoading(false);
        }
      }
    }, 1000);

    return () => clearTimeout(delayDebounceFn);
  }, [userInfo, searchData, hasChecked]);
  useEffect(() => {
    var sum = 0;
    if (dataS.chInvoicePatternCode === "CurrSale") {
      seleted.map((item) => {
        sum +=
          item?.flCurrencyAmount * item?.moCurrencyExchangePrice -
          item.moDiscount;
      });
    } else {
      seleted.map((item) => {
        sum += item?.flAmount * item?.moUnitPrice - item.moDiscount;
      });
    }

    setMoney(sum);
  }, [seleted]);
  return (
    <div className="loginTab">
      <Tabs
        value={value}
        onChange={handleChange}
        aria-label="basic tabs example"
      >
        <Tab label=" جستجوی اقلام " {...a11yProps(0)} />
        <Tab
          className="middle"
          label={` اقلام صورتحساب (${
            seleted.filter((item) => item?.flAmount !== 0)?.length
          })`}
          {...a11yProps(1)}
        />
      </Tabs>
      <TabPanel dir={"rtl"} value={value} index={0}>
        <div className="flex flex-col gap-4 md:grid grid-cols-3 p-2">
          <div className=" col-span-3 ">
            <div className=" border-b pb-2 mb-2  ">
              <div className="overflow-x-auto customeScroll2">
                {allGroups?.length > 0 ? (
                  <div className="flex md:pb-2 min-w-max gap-4 overflow-x-auto items-center">
                    <Button
                      color={selectedGroup === null ? "primary" : "inherit"}
                      variant={
                        selectedGroup === null ? "contained" : "outlined"
                      }
                      className="!text-xs !shadow-none"
                      onClick={() => setSelectedGroup(null)}
                    >
                      همه موارد
                    </Button>
                    {allGroups.map((item, index) => (
                      <Button
                        key={index + "products-groups"}
                        color={
                          selectedGroup?.guidRecNo === item.guidRecNo
                            ? "primary"
                            : "inherit"
                        }
                        variant={
                          selectedGroup?.guidRecNo === item.guidRecNo
                            ? "contained"
                            : "outlined"
                        }
                        className="!text-xs !shadow-none"
                        onClick={() => setSelectedGroup(item)}
                      >
                        {item.chName}
                      </Button>
                    ))}{" "}
                  </div>
                ) : (
                  <></>
                )}
              </div>

              <div className=" flex items-end justify-between gap-4">
                {" "}
                <div className="flex gap-1 mt-5 items-center">
                  <span className="text-sm font-bold">
                    تعداد موارد یافت شده :‌
                  </span>
                  <span className="text-sm font-bold">
                    {(searchData ? data : Idata)?.length}
                  </span>
                </div>
                {isMd && (
                  <div className="mt-4">
                    <Search
                      search={searchData}
                      setSearch={(e) => setSearchData(e.target.value)}
                    />
                  </div>
                )}
                <IconButton
                  onClick={() => getData()}
                  sx={{ padding: "0px !important" }}
                >
                  <LoopIcon
                    color="primary"
                    sx={{
                      color: (theme) =>
                        theme.palette.mode === "light"
                          ? ""
                          : "#fff  !important",
                    }}
                  />
                </IconButton>
              </div>
              {!isMd && (
                <div className="mt-4">
                  <Search
                    search={searchData}
                    setSearch={(e) => {
                      setSearchData(e.target.value);
                      setHasChecked(true);
                    }}
                  />
                </div>
              )}
            </div>
          </div>
          {loading ? (
            <>
              <Skeleton
                variant="rounded"
                width={"100%"}
                animation="wave"
                height={140}
              />{" "}
              <Skeleton
                variant="rounded"
                width={"100%"}
                animation="wave"
                height={140}
              />{" "}
              <Skeleton
                variant="rounded"
                width={"100%"}
                animation="wave"
                height={140}
              />
            </>
          ) : (
            <>
              {(searchData ? data : Idata)?.map((item, index) => (
                <Fragment key={index}>
                  <Box
                    className={`flex flex-col gap-4 border border-solid p-4 rounded-md ${
                      /*      seleted.find(
                        (i) => i.guidSellerStuffRecNo === item?.guidRecNo
                      ) &&
                      seleted.find(
                        (i) => i.guidSellerStuffRecNo === item?.guidRecNo
                      )?.flAmount !== 0
                        ? "selectedBox"
                        : */ !seleted.find(
                        (i) => i.guidRecNo === item?.guidRecNo
                      ) ||
                      seleted.find((i) => i.guidRecNo === item?.guidRecNo)
                        ?.flAmount === 0
                        ? "unSelectedBox"
                        : "selectedBox"
                    }`}
                  >
                    <ProductCart
                      data={
                        seleted.find(
                          (i) =>
                            i.guidRecNo === item?.guidRecNo ||
                            i.guidSellerStuffRecNo === item?.guidRecNo
                        ) || item
                      }
                      setData={(e) => {
                        var temp = [...seleted];
                        var indexed = seleted.findIndex(
                          (i) => i.guidRecNo === item?.guidRecNo
                        );
                        if (indexed !== -1) {
                          temp[indexed] = e;
                        } else {
                          temp.push(e);
                        }
                        setSeleted(temp);
                      }}
                      type={dataS.chInvoicePatternCode}
                      defaults={{
                        guidCurrencyTypeRecNo: localStorage.getItem(
                          "guidCurrencyTypeRecNo"
                        )
                          ? localStorage.getItem("guidCurrencyTypeRecNo")
                          : dataS.guidCurrencyTypeRecNo,
                      }}
                      currencyOption={currencyOption}
                    />
                  </Box>
                </Fragment>
              ))}
            </>
          )}
        </div>
      </TabPanel>
      <TabPanel dir={"rtl"} value={value} index={1}>
        <div className="flex flex-col gap-4 md:grid grid-cols-3 p-2">
          <div className=" col-span-3 ">
            <div className=" border-b pb-2 mb-2  ">
              <div className=" flex items-end justify-between gap-4">
                {" "}
                <div className="flex gap-1 mt-5 items-center">
                  <span className="text-sm font-bold">
                    مجموع پس از کسر تخفیف: ‌
                  </span>
                  <span className="text-sm font-bold">
                    {money.toLocaleString("en-US")} ریال{" "}
                  </span>
                </div>
              </div>
            </div>
          </div>
          {loading ? (
            <>
              <Skeleton
                variant="rounded"
                width={"100%"}
                animation="wave"
                height={140}
              />{" "}
              <Skeleton
                variant="rounded"
                width={"100%"}
                animation="wave"
                height={140}
              />{" "}
              <Skeleton
                variant="rounded"
                width={"100%"}
                animation="wave"
                height={140}
              />
            </>
          ) : (
            <>
              {seleted?.map((item, index) => (
                <Fragment key={index}>
                  {item?.flAmount || item?.flCurrencyAmount ? (
                    <Box
                      className={`flex flex-col gap-4 border border-solid p-4 rounded-md  ${
                        true ? "unSelectedBox" : "selectedBox"
                      }`}
                    >
                      <ProductCart
                        data={item}
                        setData={(e) => {
                          var temp = [...seleted];
                          var indexed = seleted.findIndex(
                            (i) => i.guidRecNo === item?.guidRecNo
                          );
                          if (indexed !== -1) {
                            temp[indexed] = e;
                          } else {
                            temp.push(e);
                          }
                          setSeleted(temp);
                        }}
                        type={dataS.chInvoicePatternCode}
                        currencyOption={currencyOption}
                        defaults={{
                          guidCurrencyTypeRecNo: localStorage.getItem(
                            "guidCurrencyTypeRecNo"
                          )
                            ? localStorage.getItem("guidCurrencyTypeRecNo")
                            : dataS.guidCurrencyTypeRecNo,
                        }}
                      />
                    </Box>
                  ) : (
                    <></>
                  )}
                </Fragment>
              ))}
            </>
          )}
        </div>
      </TabPanel>
    </div>
  );
};

export default Step3;
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <>
          <>{children}</>
        </>
      )}
    </div>
  );
}
